import type { AssetVersionCommentDto } from '@api/Api';

export function getPlayheadSyncSeconds(
  playerTime: (number | null)[],
  selectedCommentId: string | null,
  commentsList: AssetVersionCommentDto[]
): number | null {
  const fromPlayer = playerTime[0];
  if (typeof fromPlayer === 'number' && Number.isFinite(fromPlayer)) {
    return Math.max(0, fromPlayer);
  }

  if (
    !selectedCommentId ||
    selectedCommentId === 'new' ||
    selectedCommentId === 'reply'
  ) {
    return null;
  }

  const comment = commentsList.find((c) => c.id === selectedCommentId);
  const fromComment = comment?.timeCode?.fromSeconds;
  if (typeof fromComment === 'number' && Number.isFinite(fromComment)) {
    return Math.max(0, fromComment);
  }

  return null;
}
